// Ambassador landing page - deterministic scarcity bar logic.
//
// computeSpots is pure and exported so ambassador_scarcity.test.mjs can
// import it directly in Node. The DOM initializer below is guarded so this
// same file can be imported in Node (for the test) without touching `document`.
//
// Algorithm (see docs/superpowers/sdd/task-5-brief.md):
//   cycle    = ceil((max - min) / step) weeks
//   weeks    = floor((now - anchor) / 604800000)
//   fill     = min + step * (weeks % cycle), capped at max
//   remaining = 100 - fill
const WEEK_MS = 604800000;

export function computeSpots(nowMs, anchorMs, { min = 75, max = 92, step = 2 } = {}) {
  const cycle = Math.ceil((max - min) / step);
  const weeksElapsed = Math.floor((nowMs - anchorMs) / WEEK_MS);
  // Guard against negative modulo for times before the anchor.
  const weekInCycle = ((weeksElapsed % cycle) + cycle) % cycle;
  const fill = Math.min(min + step * weekInCycle, max);
  const remaining = 100 - fill;
  return { fill, remaining };
}

function initScarcityBar() {
  const el = document.getElementById('amb-scarcity');
  if (!el) return;

  const anchorAttr = el.getAttribute('data-anchor');
  if (!anchorAttr) return;
  const anchorMs = Date.parse(anchorAttr + 'T00:00:00Z');
  if (Number.isNaN(anchorMs)) return;

  const { fill } = computeSpots(Date.now(), anchorMs, { min: 75, max: 92, step: 2 });

  const fillEl = el.querySelector('.amb2-scarcity__fill');
  if (fillEl) fillEl.style.width = fill + '%';

  // Label lives inside the fill (orange) side and always shows the fill
  // value, not remaining. It stays a child of .amb2-scarcity__fill in the
  // markup, so it moves with the fill width automatically.
  const readoutEl = el.querySelector('.amb2-scarcity__readout');
  if (readoutEl) readoutEl.textContent = `${fill}%`;
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScarcityBar);
  } else {
    initScarcityBar();
  }

  window.PO_scarcity = { computeSpots, init: initScarcityBar };
}
